<template>
  <div class="api-key-created-date-table-cell">
    <div class='api-key-created-date-table-cell__date'>
      {{ formattedDate }}
    </div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'ApiKeyCreatedDateTableCell',
  props: {
    item: {
      type: Object,
      required: true,
    },
    column: {
      type: Object,
      required: true,
    },
  },
  computed: {
    formattedDate() {
      return moment(this.item.createdDate).format('yyyy-MM-DD');
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/design-system";

.api-key-created-date-table-cell {
  display: flex;
  flex-direction: column;
  justify-content: center;
  &__date {
  }
}

</style>
